import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { PromoBannerComponent } from '@shared/modules/shared-banners/components/promo-banner/promo-banner.component';

@NgModule({
  declarations: [
    PromoBannerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    PromoBannerComponent,
  ]
})
export class SharedBannersModule { }
